<template>
  <scroll-bar>
    <div class="aa">
      <img
        src="../../../../assets/images/zxx.png"
        style="max-width:100%;max-height: 100%; display: block;
        margin: auto;"
      />
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes () {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse () {
      return !this.sidebar.opened
    }
  }
}
</script>
<style scoped>
.aa {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue